import { render, staticRenderFns } from "./add-to-cart-slide-modal-product.vue?vue&type=template&id=608dcfb7&"
import script from "./add-to-cart-slide-modal-product.vue.ts?vue&type=script&lang=ts&"
export * from "./add-to-cart-slide-modal-product.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports